<template>
    <div class="payment-method moyasar-applepay">
        <div class="moyasar-applepay-header">
            <div class="left">
                <AppleIcon />
            </div>
            <span class="center">{{ $t("m.applePay") }}</span>
        </div>
        <div
            :key="formKey"
            ref="moyasarApplePayForm"
            class="mysr-form"
        ></div>
    </div>
</template>

<script>
import AppleIcon from "../../../components/icons/AppleIcon.vue";
import {
    ensureAssetsLoaded,
    initMoyasarForm,
    prepareMoyasarPayment,
} from "@/services/paymentHandlers/moyasarShared";

export default {
    name: "MoyasarInlineApplePay",
    components: {
        AppleIcon,
    },
    props: {
        selectedSubscription: {
            type: Object,
            default: () => ({}),
        },
        authorizationSubscriptionId: {
            type: [String, Number],
            default: undefined,
        },
        deviceCode: {
            type: [String, Number],
            default: "",
        },
        outletId: {
            type: [String, Number],
            default: undefined,
        },
        paymentConfig: {
            type: Object,
            required: true,
        },
        createPaymentOrder: {
            type: Function,
            required: true,
        },
        doSubscriptionPayment: {
            type: Function,
            required: true,
        },
        toast: {
            type: Function,
            default: undefined,
        },
    },
    data() {
        return {
            formKey: 0,
            initializeToken: 0,
        };
    },
    mounted() {
        this.initializeForm();
    },
    watch: {
        selectedSubscription: {
            deep: true,
            handler() {
                this.initializeForm();
            },
        },
        deviceCode() {
            this.initializeForm();
        },
        paymentConfig: {
            deep: true,
            handler() {
                this.initializeForm();
            },
        },
    },
    methods: {
        async initializeForm() {
            const token = ++this.initializeToken;

            if (
                !this.paymentConfig?.moyasarGatewayId ||
                typeof this.createPaymentOrder !== "function" ||
                typeof this.doSubscriptionPayment !== "function"
            ) {
                return;
            }

            try {
                await ensureAssetsLoaded();
                const paymentData = await prepareMoyasarPayment({
                    selectedMethod: "applepay",
                    selectedSubscription: this.selectedSubscription,
                    deviceCode: this.deviceCode,
                    outletId: this.outletId,
                    config: this.paymentConfig,
                    authorizationSubscriptionId:
                        this.authorizationSubscriptionId,
                    createPaymentOrder: this.createPaymentOrder,
                    doSubscriptionPayment: this.doSubscriptionPayment,
                });

                if (token !== this.initializeToken) return;

                this.formKey += 1;
                await this.$nextTick();

                if (token !== this.initializeToken) return;

                initMoyasarForm({
                    element: this.$refs.moyasarApplePayForm,
                    selectedMethod: "applepay",
                    amount: paymentData.amount,
                    currency: paymentData.currency,
                    internalId: paymentData.internalId,
                    givenId: paymentData.givenId,
                    publishableKey: paymentData.publishableKey,
                    config: this.paymentConfig,
                });
            } catch (error) {
                if (token !== this.initializeToken) return;
                this.formKey += 1;
                if (typeof this.toast === "function") {
                    this.toast(error?.message || "Payment failed");
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.payment-method.moyasar-applepay {
    display: block;
    padding: 17px 14px 14px;
}

.payment-method.moyasar-applepay .moyasar-applepay-header {
    display: flex;
    align-items: center;
}

.payment-method.moyasar-applepay .mysr-form {
    margin-top: 12px;
}
</style>
